exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".bb-footer {\n  background-color: #1C1C1C;\n  color: #E2E6E6;\n  font-family: \"Roboto\"; }\n  .bb-footer .center-container {\n    width: 100%;\n    height: 100%;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-pack: center;\n    justify-content: center;\n    -ms-flex-align: center;\n    align-items: center; }\n  .bb-footer .social-media {\n    margin-left: 10px;\n    margin-right: 10px;\n    font-size: 25px;\n    color: white;\n    -webkit-transition: all 0.5s ease-in-out;\n    -o-transition: all 0.5s ease-in-out;\n    transition: all 0.5s ease-in-out; }\n    .bb-footer .social-media:hover {\n      color: gray; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/lib/loader.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/footer/footer.scss
// module id = 133
// module chunks = 0